import React, { createContext, useContext, useState } from "react";

export const DEFAULT_SOURCE_TABLE = "public.hexagons";

interface AdminToolsContextValue {
  adminModeEnabled: boolean;
  setAdminModeEnabled: React.Dispatch<React.SetStateAction<boolean>>;

  isAdmin: boolean;

  url: string;
  table: string;

  setUrl: (url: string) => void;
  setTable: (table: string) => void;
}

export const AdminToolsContext = createContext<
  AdminToolsContextValue | undefined
>(undefined);

export const AdminToolsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [adminModeEnabled, setAdminModeEnabled] = useState(true);

  const isAdmin =
    !!new URLSearchParams(window.location.search).get("admin") &&
    adminModeEnabled;

  const [url, setUrl] = useState(__MARTIN_URL__);
  const [table, setTable] = useState(DEFAULT_SOURCE_TABLE);

  return (
    <AdminToolsContext.Provider
      value={{
        adminModeEnabled,
        setAdminModeEnabled,

        isAdmin,

        url,
        table,

        setUrl,
        setTable,
      }}
    >
      {children}
    </AdminToolsContext.Provider>
  );
};

export const useAdminToolsDataContext = (): AdminToolsContextValue => {
  const ctx = useContext(AdminToolsContext);
  if (!ctx) {
    throw new Error(
      "useAdminToolsDataContext must be used within AdminToolsProvider"
    );
  }
  return ctx;
};
